import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=0ab26066&"
import script from "./ActiveFilters.vue?vue&type=script&lang=ts&"
export * from "./ActiveFilters.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChip,VChipGroup})
